import client from "@/utils/axios";

export default {
  namespaced: true,

  state: {
    agreements: [],
    acceptedAgreements: [],
  },

  actions: {
    async fetchAgreements({ commit }) {
      try {
        const { data } = await client.get("/api/agreements");

        commit("setAgreements", data);
      } catch (error) {
        const { message, stack } = error;
        console.log('failed to fetch agreements', { message, stack });
        commit("setAgreements", []);
      }
    },
    async fetchMyAgreements({ commit }) {
      try {
        const { data } = await client.get("/api/my/agreements");

        commit("setAcceptedAgreements", data);
      } catch (error) {
        const { message, stack } = error;
        console.log('failed to fetch accepted agreements', { message, stack });
        commit("setAcceptedAgreements", []);
      }
    },    
    async acceptAgreement({ commit }, payload) {
      const { data } =  await client.post("/api/my/agreements", payload);

      commit("updateAcceptedAgreement", data);
    }
  },

  mutations: {
    setAgreements(state, data) {
      state.agreements = data;
    },
    setAcceptedAgreements(state, data) {
      state.acceptedAgreements = data;
    },
    updateAcceptedAgreement(state, data) {
      const { type, version, acceptedAt } = data;
      const acceptedAgreements = state.acceptedAgreements.slice();

      const agreement = acceptedAgreements.find((item) => item.type === type);

      if (!agreement) {
        acceptedAgreements.push(data);
      } else {
        agreement.version = version;
        agreement.acceptedAt = acceptedAt;
      }

      state.acceptedAgreements = acceptedAgreements;
    },    
  },
};
